import {FormikErrors, useFormik} from "formik";
import {Calendar} from "primereact/calendar";
import React, {useEffect, useState} from "react";
import DialogFooter from "../../../shared/components/generic/dialog/DialogFooter";
import {Dropdown} from "primereact/dropdown";
import {classNames} from "primereact/utils";
import Project from "../../../models/Project";
import {convertFromDate} from "../../../shared/utils/DateUtils";
import {downloadFile} from "../../../shared/api/endpoints/CrudApi";
import Employee from "../../../models/Employee";
import {Divider} from "primereact/divider";
import {EButtonIcons} from "../../../shared/components/generic/button/GenericButton";
import {IClassicExcelTemplateProps, MainExcelInfoForEricssonTemplate} from "../generic/GenericExport";
import {getAllEmployees, getAllProjects} from "../../../shared/api/GetFormData";

/**
 * Has one employee and one project for selecting
 * @param props ClassicExcelTemplateProps
 * @constructor
 */
function ClassicExcelTemplate(props: IClassicExcelTemplateProps) {

    const [dateFrom, setDateFrom] = useState<any>(undefined);
    const [dateTo, setDateTo] = useState<any>(undefined);
    const [value,] = useState<MainExcelInfoForEricssonTemplate>(MainExcelInfoForEricssonTemplate.getBlank(props.columnValues));
    const [projects, setProjects] = useState<Project[]>();
    const [employees, setEmployees] = useState<Employee[]>();

    useEffect(() => {
        getAllProjects().then((res) => {
            setProjects(res);
        });
        getAllEmployees().then((res) => {
            setEmployees(res);
        });
    }, []);

    function setDatesFrom(date: Date) {
        setDateFrom(date);
        formik.setFieldValue("dateFrom", convertFromDate(date));
        formik.setFieldValue("dateFromToShowOnForm", date);
    }

    function setDatesTo(date: Date) {
        setDateTo(date);
        formik.setFieldValue("dateTo", convertFromDate(date));
        formik.setFieldValue("dateToToShowOnForm", date);
    }

    function setProject(project: Project) {
        formik.setFieldValue("project", project);
    }

    const formik = useFormik({
        initialValues: value,
        validate: (values: MainExcelInfoForEricssonTemplate) => {
            let errors: FormikErrors<MainExcelInfoForEricssonTemplate> = {};
            if (!values.dateFrom) {
                errors.dateFrom = "Datum od je obavezno polje.";
            }
            if (!values.dateTo) {
                errors.dateTo = "Datum do je obavezno polje."
            }
            if (!values.project) {
                errors.project = "Obavezno je izabrati projekt.";
            }
            if (!values.employee) {
                errors.employee = "Obavezno je izabrati zaposlenika."
            }
            return errors;
        },

        onSubmit:
            async values => {
                values = MainExcelInfoForEricssonTemplate.revertMainExcelInfo(values);
                await downloadFile(props.url, values);

                props.hide();
            },
    });

    const formikTouched: any = formik.touched;
    const formikErrors: any = formik.errors;

    const isFormFieldValid = (name: string) => !!(formikTouched[name] && formikErrors[name]);
    const getFormErrorMessage = (name: string) => {
        return isFormFieldValid(name) && <small className="p-error">{formikErrors[name]}</small>;
    };

    return (

        <form>
            <div>
                <div style={{border: "transparent"}}>
                    <div className="p-fluid grid" style={{paddingTop: '20px'}}>
                        <div className="field col-5 md:col-5 col-offset-1">
                                <span className="p-float-label">
                                    <Dropdown id="project" optionLabel="name" name="name"
                                              dataKey="name" filter
                                              value={formik.values.project}
                                              options={projects}
                                              onChange={(e) => {
                                                  setProject(e.value);
                                                  formik.setFieldValue('project', e.value);
                                              }}/>
                                    <label htmlFor="project"
                                           className={classNames({'p-error': isFormFieldValid('project')})}>Projekt</label>
                                </span>
                            {getFormErrorMessage('project')}
                        </div>
                        <div className="field  col-5 md:col-5 ">
                            <span className="p-float-label">
                                <Dropdown id="employee" optionLabel="displayName" name="employee"
                                          dataKey="displayName" filter
                                          value={formik.values.employee}
                                          options={employees}
                                          onChange={(e) => {
                                              formik.setFieldValue('employee', e.value);
                                          }
                                          }/>
                                <label htmlFor="employee"
                                       className={classNames({'p-error': isFormFieldValid('employee')})}>Zaposlenik</label>
                            </span>
                            {getFormErrorMessage('employee')}
                        </div>
                        <Divider/>
                        <div className="field col-5 md:col-5 col-offset-1">
                            <span className="p-float-label">
                                <Calendar name="dateFrom" id="dateFrom"
                                          dateFormat="dd.mm.yy."
                                          value={dateFrom}
                                          onChange={(e) => setDatesFrom(e.value as Date)}/>
                                <label htmlFor="dateFrom"
                                       className={classNames({'p-error': isFormFieldValid('dateFrom')})}>Datum od</label>
                            </span>
                            {getFormErrorMessage('dateFrom')}
                        </div>
                        <div className="field col-5 md:col-5">
                            <span className="p-float-label">
                                  <Calendar name="dateTo" id="dateTo"
                                            dateFormat="dd.mm.yy."
                                            value={dateTo}
                                            onChange={(e) => setDatesTo(e.value as Date)}/>
                                  <label htmlFor="dateTo"
                                         className={classNames({'p-error': isFormFieldValid('dateTo')})}>Datum do</label>
                            </span>
                            {getFormErrorMessage('dateTo')}
                        </div>
                    </div>
                </div>

                <DialogFooter
                    hide={props.goBack}
                    onClick={formik.handleSubmit}
                    firstButtonLabel="Nazad"
                    firstButtonIcon={EButtonIcons.ANGLE_LEFT}
                    secondButtonLabel="Download"/>
            </div>
        </form>
    );
}

export default ClassicExcelTemplate;